export default {"src":"/_next/static/media/business1.69927fcf.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};